import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { SUPPORT_EMAIL } from '@/config/admin';

/**
 * Récupère l'adresse e-mail de support configurée par l'administrateur.
 * En cas d'indisponibilité, on retombe sur l'adresse de repli.
 */
export function useSupportEmail(): string {
  const [email, setEmail] = useState<string>(SUPPORT_EMAIL);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await supabase
          .from('admin_settings')
          .select('support_email')
          .eq('id', 'default')
          .maybeSingle();
        const value = (data as { support_email?: string } | null)?.support_email;
        if (active && value && value.trim()) setEmail(value.trim());
      } catch {
        /* on conserve l'adresse de repli */
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return email;
}